import { combineReducers } from 'redux';
import wrapperReducer from 'guardian/comp/wrapper/wrapperReducer';
import accountsReducer from 'guardian/comp/accounts/accountsReducer';
import scansReducer from 'guardian/comp/scans/scansReducer';
import dashboardReducer from 'guardian/comp/dashboard/dashboardReducer';
import authReducer from 'guardian/comp/login/authReducer';
import apiKeysReducer from 'guardian/comp/apiKeys/apiKeysReducer';
import membersReducer from 'guardian/comp/settings/membersReducer';

export default combineReducers({
  auth: authReducer,
  wrapper: wrapperReducer,
  accounts: accountsReducer,
  scans: scansReducer,
  dashboard: dashboardReducer,
  apiKeys: apiKeysReducer,
  members: membersReducer,
});
